import * as React from 'react';


export default class SelectMore extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <polygon id="Triangle" points="2.66666667 0 5.33333333 5.33333333 0 5.33333333"></polygon>
        <polygon id="Triangle-Copy" transform="translate(2.666667, 9.333333) scale(1, -1) translate(-2.666667, -9.333333) " points="2.66666667 6.66666667 5.33333333 12 0 12"></polygon>
      </svg>
    )
  }
}
